export interface TranslatableError {
  i18nKey: string;
}

export class PaymentError extends Error implements TranslatableError {
  constructor(message = 'Payment error', public readonly i18nKey = 'fv_snackbar.payment.error_msg') {
    super(message);
  }

  static extractKey(error: unknown): string {
    if (error instanceof PaymentError) {
      return error.i18nKey;
    }

    if (error instanceof Error) {
      return error.message;
    }

    return typeof error === 'string' ? error : 'fv_snackbar.payment.error_msg';
  }
}

export class PaymentPollingTimeoutError extends PaymentError {
  constructor() {
    super('We couldn’t confirm the payment status. Please check the terminal.', 'fv_snackbar.card.pending_timeout_msg');
  }
}

export class PaymentPollingFailedError extends PaymentError {
  constructor() {
    super('The payment could not be completed. Please check the terminal.', 'fv_snackbar.card.failed_status_checking_msg');
  }
}

export class PaymentStatusNetworkError extends PaymentError {
  constructor() {
    super('Network error while checking payment status', 'fv_confirm.payment.error_no_connection_payment');
  }
}

export class PaymentCheckoutError extends PaymentError {
  constructor() {
    super('Could not process payment', 'fv_confirm.payment.error_card_payment');
  }
}

export class PaymentPollingCancelledError extends PaymentError {
  constructor() {
    super('Polling cancelled by user', 'fv_snackbar.payment.polling_cancelled_msg');
  }
}

export class PaymentCancelledError extends PaymentError {
  constructor() {
    super('Payment cancelled by user', 'fv_snackbar.payment.cancelled_msg');
  }
}
